/**
* User Personalization Module
* 
* Personalization module for storing and retrieving user access affinities
* Storing in HTML5 Local Storage using the SCM.Utilities.LocalStorage module
* Sample Format: {Items: [{id:"1234567",type:"article",date:
*/

var SCM = SCM || {};
SCM.Utilities = SCM.Utilities || {};
SCM.Utilities.LocalStorage = SCM.Utilities.LocalStorage || {};
SCM.SharedWidgets = SCM.SharedWidgets || {};

SCM.SharedWidgets.UserPersonalization = (function() {

    var _storageKey = 'SharedWidgets.UserAffinities';

    return {
        AddToLocalStorage: addToLocalStorage,
        GetFromLocalStorage: getFromLocalStorage,
        GetUserAffinityRecResults: getUserAffinityRecResults
    };


    /**
    * Finds elements in the dom with the class name, grabs the attribute which is expected as a JSON object, and pushes it to local storage
    *
    * @param {string} elementClass - The CSS class on the DOM element
    * @param {string} elementAttr - The data attribute to retrieve the JSON object
    */
    function addToLocalStorage(elementClass, elementAttr) {
        // Find all elements in the dom with the class and attribute
        var $domItem = $(elementClass);
        if ($domItem.length !== 0) {
            var maxDaysOfItemsToRetain = $domItem.attr('data-days-to-retain');
            var resourceId = $domItem.attr('data-resource-id');
            var resourceType = $domItem.attr('data-resource-type');

            // Get the item currently stored in local storage
            var localObject = getFromLocalStorage();

            // if there was nothing in local storage, initialize it to an empty array
            localObject = localObject ? localObject : { Items: [] };
            var parsedLocalItems = localObject.Items;

            // clean up any items older than the configured days.
            parsedLocalItems = pruneLocalStorageItems(parsedLocalItems, maxDaysOfItemsToRetain);

            var requestParams = { resourceId: resourceId, resourceTypeId: resourceType };
            SCM.Ajax.get('/Personalization/GetCategoriesForResource', requestParams)
                .expectJson()
                .then(function (result) {
                    if (result.Categories.length > 0) {
                        parsedLocalItems.push(result);
                    }

                    localObject.Items = parsedLocalItems;

                    // set it in local storage
                    SCM.Utilities.LocalStorage.setItem(_storageKey, localObject);
                });
        }
    }

    /**
    * Retrieves the UserPersonalization information from local storage
    */
    function getFromLocalStorage() {
        return SCM.Utilities.LocalStorage.getItem(_storageKey);
    }

    function pruneLocalStorageItems(localItems, maxDays) {
        var today = new Date();
        var dateToPrune = new Date(new Date().setDate(today.getDate() - maxDays));

        var prunedItems = localItems.filter(function (item) {
            return new Date(item.Date) >= dateToPrune;
        });

        return prunedItems;
    }

    function getUserAffinityRecResults(containerId, instanceId, siteId) {
        var userAffinities = getFromLocalStorage();

        if (!userAffinities || !userAffinities.Items.length) {
            return;
        }

        var $currentResourceTracking = $('.SCM-SharedWidgets-LocalStorage-UserAffinityTracking');
        var currentResourceId = $currentResourceTracking.data('resource-id');
        var currentResourceType = $currentResourceTracking.data('resource-type');

        var items = userAffinities.Items;
        
        SCM.Ajax.post('/Personalization/UserAffinityRecSearchResults/' + instanceId,
            {
                userAffinityJson: JSON.stringify(items),
                currentResourceId: currentResourceId,
                currentResourceType: currentResourceType,
                siteId: siteId
            })
            .expectHtml()
            .then(function (result) {
                $('#' + containerId).html(result);
            });
    }
})();
